import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import PlayerActionsBar from './PlayerActionsBar';
window.mountPlayerActionsBar = function mountPlayerActionsBar(containerId, props) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error('PlayerActionsBar: container not found:', containerId);
        return { unmount: () => { }, get api() { return null; } };
    }
    const apiRef = createRef();
    const root = createRoot(container);
    root.render(React.createElement(PlayerActionsBar, { ...props, ref: apiRef }));
    return {
        unmount: () => root.unmount(),
        get api() { return apiRef.current; },
    };
};
